<template>
    <section>
        <Horizontal v-if="model.viewDirection === 'horizontal'" :model="model"/>
        <Vertical v-if="model.viewDirection === 'vertical'" :model="model"/>
    </section>
</template>

<script>
import Horizontal from './Horizontal.vue';
import Vertical from './Vertical.vue';
export default {
    props: ['model'],
    components: {
        Horizontal,
        Vertical
    }
};
</script>
